<mat-card>
  <app-card-header
    [title]="title"
    icono="category"
    [draggable]="!!dialogRef"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  @if (form) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <mat-card-content class="card-content-crear">
        @if (data.categorias && data.categorias.length > 1) {
          <section class="inputs-group">
            <ng-select
              [items]="data.categorias"
              formControlName="categoria"
              placeholder="Tipo de categoría"
              [clearable]="false"
              appendTo="body"
              notFoundText="Sin resultados"
              style="width: 100%"
              required
            >
              <ng-template ng-label-tmp let-item="item">
                {{ formatearCategoria(item) }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ formatearCategoria(item) }}
              </ng-template>
            </ng-select>
          </section>
        }

        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" required />
          </mat-form-field>
        </section>

        @if (helper.esNivel0()) {
          <mat-checkbox color="primary" formControlName="global">
            Global
          </mat-checkbox>
        }
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          [disabled]="!this.form.valid || loading"
          type="submit"
        >
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  }
</mat-card>
